const UserCreateAccountSelectManager = {
  'pages_user_UserCreateAccountSelectManager.1': '담당자 선택',
  'pages_user_UserCreateAccountSelectManager.2': '계정 생성을 위해 담당자를 선택하세요.',
  'pages_user_UserCreateAccountSelectManager.3': '기본 정보 선택',
  'pages_user_UserCreateAccountSelectManager.4': '계정 생성을 위해 회사를 선택하세요.',
  'pages_user_UserCreateAccountSelectManager.5': '세부 정보 선택',
  'pages_user_UserCreateAccountSelectManager.placeholder.1': '홍길동',
  'pages_user_UserCreateAccountSelectManager.placeholder.2': 'UI/UX팀',
  'pages_user_UserCreateAccountSelectManager.constract': '계약 내용',
  'pages_user_UserCreateAccountSelectManager.constract.add': '계약 내용 추가',
}

export default UserCreateAccountSelectManager



// WEBPACK FOOTER //
// ./src/lang/user/components/UserCreateAccountSelectManager.kr.js